import type { ClientItemId } from 'owa-client-ids';
import type EventScope from 'owa-service/lib/contract/EventScope';
import type ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import { action } from 'satcheljs';
import type { CalendarEventContextMenuViewState } from '../store/schema/CalendarEventContextMenuViewState';
import type { ViewType } from 'owa-calendar-actions';

export const fetchEventData = action('fetchEventData', (itemId: ClientItemId) => ({
    itemId,
}));

export const verifyEventData = action('verifyEventData', (handleItemRemoved?: () => void) => ({
    handleItemRemoved,
}));

export const updateInitializedEventId = action(
    'updateInitializedEventId',
    (itemId: ClientItemId | null) => ({ itemId })
);

export const editEvent = action('editEvent', (eventScope: EventScope) => ({ eventScope }));

export const replyToMeeting = action('replyToMeeting', (isReplyAll: boolean) => ({
    isReplyAll,
}));

export const forwardEvent = action('forwardEvent', (eventScope: EventScope) => ({
    eventScope,
}));

export const respondToMeeting = action(
    'respondToMeeting',
    (newResponseType: ResponseTypeType, eventScope: EventScope, editorTitleText: string) => ({
        newResponseType,
        eventScope,
        editorTitleText,
    })
);

export const proposeNewTime = action(
    'proposeNewTime',
    (editorTitleText: string, responseType: ResponseTypeType) => ({
        editorTitleText,
        responseType,
    })
);

export const deleteEvent = action('deleteEvent', (eventScope: EventScope) => ({ eventScope }));

export const cancelMeeting = action(
    'cancelMeeting',
    (eventScope: EventScope, editorTitleText: string) => ({ eventScope, editorTitleText })
);

export const openEventContextMenu = action(
    'openEventContextMenu',
    (sourceId: ViewType, viewState: CalendarEventContextMenuViewState) => ({
        sourceId,
        viewState,
    })
);

export const closeEventContextMenu = action('closeEventContextMenu');

export const openEventDetails = action('openEventDetails', (id: ClientItemId) => ({
    id,
}));

export const duplicateEvent = action('duplicateEvent');
